export default __webpack_public_path__ + "static/nailSalonImg-70081d5148ca7e9d2a1f4e87a0f4dd59.svg";